import React from 'react';
import { Box, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { textSizeByBreakpoint, sizeByBreakpoint } from 'utils/helper';

interface ComingSoonOverlayProps {
  show?: boolean;
  variant?: 'default' | 'compact';
  borderRadius?: string | number;
}

const ComingSoonOverlay = ({ show = true, variant = 'default', borderRadius = '16px' }: ComingSoonOverlayProps) => {
  const theme = useTheme();

  if (!show) return null;

  const fontSize = variant === 'compact' ? textSizeByBreakpoint(14) : textSizeByBreakpoint(20);
  const labelBorderRadius = variant === 'compact' ? '8px' : '10px';
  const labelHeight = variant === 'compact' ? sizeByBreakpoint(1.5, 32) : 'auto';

  return (
    <>
      {/* Blur Overlay */}
      <Box
        sx={{
          position: 'absolute',
          inset: 0,
          backdropFilter: 'blur(10px)',
          backgroundColor: 'rgba(255, 255, 255, 0.05)',
          zIndex: 3,
          border: `1px solid ${theme.palette.divider}`,
          borderRadius
        }}
      />

      {/* Coming Soon Label */}
      <Box
        sx={{
          position: 'absolute',
          display: 'flex',
          inset: 0,
          zIndex: 4,
          justifyContent: 'center',
          flexDirection: 'column',
          alignItems: 'center',
          width: '100%'
        }}
      >
        <Box sx={{ mx: '100px', textAlign: 'center' }}>
          <Typography
            sx={{
              fontSize,
              fontWeight: 700,
              color: theme.palette.primary.main,
              border: `1px solid ${theme.palette.primary.main}`,
              px: 2,
              py: 0.5,
              borderRadius: labelBorderRadius,
              marginBottom: 1,
              backgroundColor: theme.palette.background.paper,
              ...(variant === 'compact' && {
                height: labelHeight,
                display: 'inline-flex',
                alignItems: 'center'
              })
            }}
          >
            Coming Soon
          </Typography>
        </Box>
      </Box>
    </>
  );
};

export default ComingSoonOverlay;
